import {
  Component, Input, Output, EventEmitter, Directive, ChangeDetectorRef, AfterViewInit, ViewChild,
  Inject, NgZone, HostListener, ElementRef
} from '@angular/core';
import { ProductService } from './products/products.service';
import { ProductListComponent } from './products/product-list.component';
import { LoginService } from './home/login.service';
import { IRep } from './home/rep';
import { ICustomer } from './home/customer';
import { OnlineOrderService } from './onlineorder/onlineorder.service';
import { ICartItems } from './onlineorder/cartitems';
import { Subscription } from 'rxjs/';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from './onlineorder/order.service';
import { ToastrService } from 'ngx-toastr';
import { IRepPublicData } from './home/repPublicData';
import { TranslateService } from '@ngx-translate/core';
import { SUPPORTED_LANGUAGES } from './generic/supported-languages';
import { AdminService } from './admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiCacheService } from './core/api-cache.service';
import { SessionService } from './session/session.service';

//import { SessionCheckService } from './login/session-check.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  pageTitle: string = 'LBRI Sample Cart';
  @Input() shoppingCartItems$: number = 0;
  @Output() countChange: EventEmitter<number> = new EventEmitter<number>();
  //  @ViewChild(ProductListComponent)
  //  prodlist: ProductListComponent;
  locale: string;
  isSessionInvalid = false;
  showNewSessionNotice = false;
  @ViewChild('langSelect') langSelect: ElementRef;
  public myProdCount: number = 0;
  shoppingCartItems: ICartItems[];
  public myRepID: number;
  public loggedIn: boolean = false;
  public isCorp: boolean = false;
  languages = SUPPORTED_LANGUAGES;
  public myCustName: string;
  public caption: string;
  public transErrMsg: string;
  translatedText = '';
  rep!: IRepPublicData;

  cust!: ICustomer;
  // get repIdPL(): string{
  //   return this.prodlist.repId;
  // }

  title: any;
  //isMenuOpen = false;
  //toggleMenu() { this.isMenuOpen = !this.isMenuOpen; }
  // Stop Bootstrap's default "click outside" collapse
  //keepMenuOpen(event: Event) {
  //  event.stopPropagation();
 // }
goToRepSite() {
  window.location.href = `https://lbri.com/?als=${this.myRepID}`;
}
// controls the mobile nav open/close
isNavOpen = false;

toggleNav(): void {
  this.isNavOpen = !this.isNavOpen;
}

closeNav(): void {
  this.isNavOpen = false;
}

  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model =
    {
      "q": [textToTrans],
      "target": targetLang
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {

        //were gonna do it nested, couldn't do it as a standalone method.
        let model =
        {
          "q": [errorMessage],
          "target": locale
        };

        this.admin.googleTranslate(model).subscribe((response: any) => {

          let res = response.data.translations[0].translatedText as string;
          this.translatedText = response.data.translations[0].translatedText as string;
          this.transErrMsg = this.translatedText;
          localStorage.setItem('translatedText', res);


        }, error => console.log(error), () => {

          this.translate.get(subject).subscribe((res: string) => {
            this.caption = res;
            console.log(res);
          }, error => console.log(error), () => {
            this.spinner.hide();
            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000
            });
            localStorage.removeItem('translatedText');

          });
        });



        //this.transErrMsg =  this.translatedText;
      }
      else {
        this.translate.get(subject).subscribe((res: string) => {
          this.caption = res;
          console.log(res);
        }, error => console.log(error), () => {
          this.transErrMsg = errorMessage;
          this.spinner.hide();
          //once the caption is translated, fire off the toaster popup
          this.toaster.error(this.transErrMsg, this.caption, {
            timeOut: 5000
          });
          localStorage.removeItem('translatedText');
        });
      }
    }
    else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      this.spinner.hide();
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {

        timeOut: 5000
      });
    }
  }
  repId(): string {
    var currentId = localStorage.getItem('repId') || "";
    return currentId;
  }

  custName(): any {
    var currentName = localStorage.getItem('custName');
    return currentName;
  }
  logOutCust() {
    //this.orderService.clearOrder();

    // this.orderService.clearCart();
    // this.login.logOut();
    // this.login.token = null;
    // this.login.refresh_token = null;    
    // this.loggedIn = false;
    // this.login.isAuthenticated = false;
    // this.myProdCount = 0;

    this.logoutSuccess('index.toastPopup.success.logoutSuccess');
    //this.router.navigateByUrl('shop/from/' + this.repId());

  }
  // ngAfterViewInit() {
  //   this.change.detectChanges();
  // }
  logoutSuccess(message: string): void {
    this.translate.get(message).subscribe((res: string) => {
      this.transErrMsg = res;
      console.log(res);
    });

    // translate the caption
    this.translate.get('Success').subscribe((res: string) => {
      this.caption = res;
      console.log(res);
    });
    this.spinner.hide();
    //show the toaster popup
    this.toaster.success(this.transErrMsg, this.caption, {

      timeOut: 3000
    });

    setTimeout((router: Router) => {
      this.router.navigate(["/shop/from/" + localStorage.getItem('repId')]);
      this.orderService.clearCart(true);
      this.login.logOut();
      this.login.token = "";
      this.login.refresh_token = "";
      this.login.custName = "";
      this.loggedIn = false;
      this.myCustName = "";
      this.login.isAuthenticated = false;
      this.myProdCount = 0;
      localStorage.setItem("prodCount", "0");
    }, 500);
  }
  constructor(public route: ActivatedRoute, public router: Router, public _productService: ProductService,
    public login: LoginService, public orderService: OrderService, public toaster: ToastrService,
    public change: ChangeDetectorRef, public zone: NgZone, public translate: TranslateService,
    public admin: AdminService, public spinner: NgxSpinnerService, private cache: ApiCacheService, private sessionService: SessionService
  ) {
    this.sessionService.invalidated$.subscribe((value) => {
      this.isSessionInvalid = value;
    });

    this.sessionService.newSessionNotice$.subscribe((value) => {
      this.showNewSessionNotice = value;
    });
    this.shoppingCartItems = this.orderService.getCart();
    var currentRep = localStorage.getItem('repId');
    var currentName = localStorage.getItem('custName') || "";
    this.myCustName = currentName;
    this.myRepID = Number(currentRep);

    this.translate.addLangs(SUPPORTED_LANGUAGES.map(l => l.code));

    this.translate.setDefaultLang('en');
    if (localStorage.getItem('locale') !== null) {
      this.translate.setDefaultLang(this.getLocale()); // this one will change based on browser language.
      //this.translate.currentLang = this.getLocale();

      this.useLanguage(this.getLocale());
      //console.log('Current Language: ' + this.translate.currentLang);
    }

    // ── Suppress Nuvei checkout.js internal removeChild errors ────────────────
    // Nuvei's SimplyConnect SDK uses React internally and occasionally tries to
    // remove a DOM node it already removed during its own unmount cycle. This is
    // a bug inside the Nuvei SDK — our code is not the cause. We suppress only
    // this specific error from that specific file so it doesn't pollute the
    // console for the team.
    window.addEventListener('error', (event: ErrorEvent) => {
      if (
        event.message?.includes('removeChild') &&
        event.filename?.includes('checkout.js')
      ) {
        event.preventDefault();
      }
    });
  }

  useLanguage(language: string): void {
    this.translate.use(language);
    //this.translate.currentLang = language;
    localStorage.setItem('locale', language.toString());
  }

  dismissNewSessionNotice(): void {
    this.sessionService.dismissNewSessionNotice();
  }

  acknowledgeInvalidSession(): void {
    // intentionally no-op
  }

  @HostListener('window:beforeunload', ['$event'])
  public beforeUnloadHander(event: any) {

    if (this.login.loggedIn()) {
      this.orderService.clearOrderSync();
      this.orderService.clearCart(true);
      localStorage.removeItem('shippingData');
      localStorage.removeItem('cartItems');
      localStorage.removeItem('prodCount');
      localStorage.removeItem('guid');
      // localStorage.removeItem('custName');
      // this.myCustName = null;
      this.myProdCount = 0;
      localStorage.setItem("prodCount", "0");

      //this.logOutCust();
      //localStorage.clear();
      window.location.reload();
      //event.returnValue = "false";


    }
    return false;

  }

  ngOnInit(): void {

      this.cache.clear();
    console.log('AppComponent instance:', this);
    var currentRep = localStorage.getItem('repId');
    this.myRepID = Number(currentRep);

    //this.isCorp = this.myRepID === 400560;

    console.log(this.isCorp);
    var currentUser1 = JSON.parse(localStorage.getItem('authorizationData') || '{}');

    if (this.login.loggedIn()) {
      this.loggedIn = true;

      var currentName = localStorage.getItem('custName') || '{}';
      this.myCustName = currentName;
      console.log('app component thinks we are logged in. :)');
    }
    else {
      this.loggedIn = false;
      this.login.isAuthenticated = false;
    }

  }

//   ngAfterViewInit() {
//   const blockers = [
//     document.querySelector('.aloeBg'),
//     document.querySelector('.mainNav'),
//     document.querySelector('body')
//   ];

//   blockers.forEach(el => {
//     if (el) {
//       el.addEventListener('click', (event) => {
//         event.stopPropagation();
//         event.stopImmediatePropagation();
//       }, true);
//     }
//   });

//     console.log("NAVBAR RENDERED");
// }

}